export const membershipRuleKeys = {
  success : 'success',
  withoutTickets : 'withoutTickets',
  noMembership : 'noMembership',
  membershipNotFound : 'membershipNotFound',
  inactivePlan : 'inactivePlan',
  priorityRestricted : 'priorityRestricted',
} as const;
